import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  UpdateAgencyMutation as UpdateAgencyMutationType,
  UpdateAgencyMutationVariables,
} from "./__generated__/UpdateAgencyMutation";

const UpdateAgencyMutation = loader("./UpdateAgencyMutation.gql");

type UpdateAgencyMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: UpdateAgencyMutationType) => void;
}) => ReactElement;

export const UpdateAgencyMutationProvider: UpdateAgencyMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<UpdateAgencyMutationType, UpdateAgencyMutationVariables>(
    UpdateAgencyMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
